// Mock data for STG architecture studio clone
export const navLinks = [
  { label: "Despre noi", href: "#about" },
  { label: "Proiecte", href: "#projects" },
  { label: "Echipa", href: "#team" },
  { label: "Servicii", href: "#services" },
  { label: "Contact", href: "#contact" },
];

export const contactInfo = {
  email: "dumitruramonaionela75@gmail.com",
  phone: "0729 306 119",
  cities: "București • Cluj • Iași",
};

export const stats = [
  { value: "42", suffix: "", label: "Proiecte Finalizate", sub: "În România și internațional" },
  { value: "94", suffix: "%", label: "Rată de retenție clienți", sub: "An după an" },
  { value: "12", suffix: "", label: "Documentații PUD/PUZ/PUG", sub: "Aprobate și avizate" },
];

export const services = [
  {
    icon: "Building2",
    title: "Arhitectură Corporativă",
    desc: "Spații de lucru proiectate pentru a crește productivitatea și conexiunea echipei.",
  },
  {
    icon: "Landmark",
    title: "Spații Culturale & Publice",
    desc: "Clădiri care devin repere și centre comunitare pline de viață.",
  },
  {
    icon: "Home",
    title: "Rezidențial & Mixte",
    desc: "Medii de locuit bine gândite care încurajează comunitatea și confortul.",
  },
  {
    icon: "MapPinned",
    title: "Urbanism & PUD/PUZ/PUG",
    desc: "Documentații de amenajarea teritoriului și avizare completă, cu drept de semnătură.",
  },
  {
    icon: "Compass",
    title: "Design de Concept",
    desc: "Idei arhitecturale originale, transformate în viziuni funcționale și memorabile.",
  },
  {
    icon: "Layers",
    title: "Amenajări Interioare",
    desc: "Interioare rafinate, atent orchestrate pentru estetică, ergonomie și emoție.",
  },
];

export const projects = [
  {
    year: "2025",
    city: "BUCUREȘTI • STR. POLONĂ",
    title: "Polona Residence",
    desc: "Casă unifamilială contemporană cu volume suprapuse, transparențe generoase și un limbaj arhitectural minimalist care îmbină eleganța urbană cu confortul modern.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_jovial-knuth-9/artifacts/9vkzvusc_pic_cp2.jpg",
  },
  {
    year: "2024",
    city: "TUNARI",
    title: "Tunari Residences",
    desc: "Ansamblu rezidențial de 72 de locuințe, proiectat cu accent pe confort, lumină naturală și integrare în contextul suburban. Volume elegante și finisaje calde.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_jovial-knuth-9/artifacts/ro1fvvel_l1.jpg",
  },
  {
    year: "2025",
    city: "BUCUREȘTI • UVERTURII",
    title: "Uverturii Villa",
    desc: "Locuință individuală modernă cu piscină, terase generoase și grădină rafinată. Un proiect ce pune accent pe integrarea cu natura, intimitatea și confortul de zi cu zi.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_jovial-knuth-9/artifacts/2pm56e5b_pic_locUverturii2.jpg",
  },
  {
    year: "2024",
    city: "PITEȘTI",
    title: "Pitești Towers",
    desc: "Ansamblu de blocuri moderne cu 7 niveluri, apartamente luminoase, balcoane generoase și fațade cu accente calde. Un proiect rezidențial urban ce combină funcționalitatea cu estetica.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_jovial-knuth-9/artifacts/u4d5kf64_l1.jpg",
  },
];

export const team = [
  {
    name: "Vlad Cojocaru",
    role: "Arhitect Urbanist • 46 ani",
    bio: "Urbanist diplomat cu drept de semnătură pentru documentații de amenajarea teritoriului. Specializat în PUD, PUZ, PUG și promovarea lor pe traseul de avizare/autorizare.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_jovial-knuth-9/artifacts/2naq031h_WhatsApp%20Image%202026-07-16%20at%2011.22.23%20PM.jpeg",
  },
  {
    name: "Dumitru Ramona Ionela",
    role: "Arhitect & Designer de Concept • 44 ani",
    bio: "Arhitect cu experiență vastă în design de concept și amenajări interioare de înaltă calitate. Coordonează proiecte rezidențiale și corporate.",
    image: "https://customer-assets-wrfwihn1.emergentagent.net/job_jovial-knuth-9/artifacts/vjaqd1dt_WhatsApp%20Image%202026-07-17%20at%209.19.15%20AM.webp",
  },
  {
    name: "Alături de noi",
    role: "Colaboratori & Specialiști",
    bio: "Ingineri de structuri, instalații, peisagiști și specialiști în avizare — o rețea completă de experți ce susține fiecare proiect STG.",
    image: "https://images.unsplash.com/photo-1716037991590-c975184b37df",
  },
];

export const heroImage = "https://images.unsplash.com/photo-1487958449943-2429e8be8625?auto=format&fit=crop&w=1920&q=80";
